// @flow

import { useCallback } from 'react';
import { type UserInputName } from '@tectonics/prs/user-input';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export function useHandleUserInput(
  userInputValues: UserInputValues,
  setUserInputValues: (UserInputValues) => void
): (UserInputName, any) => void {

  const handleUserInput = useCallback(
    (name: UserInputName, value: any) => {
      setUserInputValues((values: UserInputValues): UserInputValues => {
        return {
          ...values,
          [name]: value,
        };
      });
    },

    [setUserInputValues],
  );

  return handleUserInput;
}
